<template>
  <span
    :class="[
      'inline-flex items-center px-2 py-1 rounded-full text-xs leading-[0.8rem] bg-muted text-fg-muted font-normal m-0',
      removable ? 'pr-1 gap-1' : '',
    ]"
  >
    <span>{{ label }}</span>
    <button
      v-if="removable"
      type="button"
      class="inline-flex items-center justify-center bg-transparent border-0 cursor-pointer p-0.5 rounded-full text-inherit leading-none hover:bg-fg/10"
      :aria-label="removeLabel"
      @click="$emit('remove')"
    >
      <font-awesome-icon :icon="['fal', 'times']" />
    </button>
  </span>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true
  },
  removable: {
    type: Boolean,
    default: false
  },
  removeLabel: {
    type: String,
    default: 'Fjern'
  }
});

defineEmits(['remove']);
</script>
